import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Treatments = () => {
  const { t } = useTranslation();

  return (
    <div className="relative py-32">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Image Section */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          viewport={{ once: true }}
          className="relative aspect-[4/3] overflow-hidden"
        >
          <img 
            src="https://res.cloudinary.com/dansvy9a5/image/upload/v1739113190/1736183405038_2_rfj0d1.jpg"
            alt="AURA IMMERSION – Wellness and self-confidence through transformative experiences in Mauritius"
            className="w-full h-full object-cover rounded-lg"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg" />
        </motion.div>

        {/* Text Section */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
          viewport={{ once: true }}
          className="flex flex-col items-start space-y-6"
        >
          <h2 className="text-4xl md:text-5xl font-serif">
            {t('treatments.experience.title')} <span className="text-[#c9ab81]">{t('treatments.experience.unique')}</span> {t('treatments.experience.and')}<br />
            {t('treatments.experience.unprecedented')}<br />
            {t('treatments.experience.dedicated')} <span className="text-[#c9ab81]">{t('treatments.experience.women')}</span> {t('treatments.experience.who')}<br />
            {t('treatments.experience.aspire')}<br />
            {t('treatments.experience.fulfillment')}<br />
            {t('treatments.experience.daily')}
          </h2>
          
          <a 
            href="https://docs.google.com/forms/d/e/1FAIpQLSc5mmPDqzUeexziQ_G5pmpiTNH2flL2p6DW5yWL2cu1lWC-6Q/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative px-8 py-3 overflow-hidden mt-6"
          >
            <div className="absolute inset-0 w-0 bg-[#c9ab81] transition-all duration-[750ms] ease-out group-hover:w-full" />
            <span className="relative text-lg font-serif group-hover:text-black transition-colors duration-[750ms]">
              {t('treatments.learnMore')}
            </span>
            <div className="absolute inset-0 border border-[#c9ab81] pointer-events-none" />
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default Treatments;